import classNames from "classnames/bind";
import styles from "./Camera.module.css";
import { FilterIcon, Previous } from "../../../../components/Icons/Icons";
import { Button, SelectBox, SelectBoxItem } from "../../../../components";
import { fillCamRole } from "./config";
import { useEffect, useRef, useState } from "react";

const cx = classNames.bind(styles);

function ModalFill({ onSubmitFill, filCode }) {
    const [fillCamModal, setFillCamModal] = useState(false)
    const refModal = useRef(null)
    const refButton = useRef(null)


    const handleShowModal = () => {
        setFillCamModal(!fillCamModal)
    }

    const handleChangeGroupCam = (data) => {
        onSubmitFill(data)
    }

    useEffect(() => {
        const handleClickOutSide = (e) => {
            // // console.log(!refModal?.current?.contains(e.target) && !refButton?.current?.contains(e.target));
            if (!refModal?.current?.contains(e.target) && !refButton?.current?.contains(e.target)) {
                setFillCamModal(false)
            }
        }
        document.addEventListener('click', handleClickOutSide);
        return () => document.removeEventListener('click', handleClickOutSide);
    }, [refModal])

    return (
        <div className={cx('filter-container')}>
            <div onClick={handleShowModal} ref={refButton}>
                <FilterIcon />
            </div>
            {fillCamModal && (
                <div className={cx('modal-fill')} ref={refModal}>
                    <div className={cx("header")}>
                        <span onClick={handleShowModal}>
                            <Previous />
                        </span>
                        <p className={cx("title")}>Bộ lọc</p>
                    </div>

                    <div className={cx("content")}>
                        <SelectBox
                            style={{ paddingBottom: 4, paddingTop: 0 }}
                            values={fillCamRole.find(item => item.value === filCode).label}
                            type="big"
                            label="Trạng thái áp dụng"
                            onChange={handleChangeGroupCam}
                        >
                            {fillCamRole?.map((item, index) => {
                                return (
                                    <SelectBoxItem
                                        label={item.label}
                                        value={item.value}
                                        key={index}
                                    />
                                )
                            })}
                        </SelectBox>
                        {/* <Button title={'Áp dụng'} onClick={handleSubmitFill} className={cx('button-fill')} /> */}
                    </div>
                </div>
            )}
        </div>
    )
}

export default ModalFill;